// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import Franklin from '../../../Texas/data/counties/Franklin.geo.json'
import Rains from '../../../Texas/data/counties/Rains.geo.json'
import Wood from '../../../Texas/data/counties/Wood.geo.json'
import Camp from '../../../Texas/data/counties/Camp.geo.json'
import Upshur from '../../../Texas/data/counties/Upshur.geo.json'
import Marion from '../../../Texas/data/counties/Marion.geo.json'
import Harrison from '../../../Texas/data/counties/Harrison.geo.json'
import Gregg from '../../../Texas/data/counties/Gregg.geo.json'
import Van_Zandt from '../../../Texas/data/counties/Van_Zandt.geo.json'
import Smith from '../../../Texas/data/counties/Smith.geo.json'
import Rusk from '../../../Texas/data/counties/Rusk.geo.json'
import Panola from '../../../Texas/data/counties/Panola.geo.json'
import Shelby from '../../../Texas/data/counties/Shelby.geo.json'
import Henderson from '../../../Texas/data/counties/Henderson.geo.json'
import Cherokee from '../../../Texas/data/counties/Cherokee.geo.json'
import Anderson from '../../../Texas/data/counties/Anderson.geo.json'
import Freestone from '../../../Texas/data/counties/Freestone.geo.json'
import Houston from '../../../Texas/data/counties/Houston.geo.json'
import Trinity from '../../../Texas/data/counties/Trinity.geo.json'

const counties = {
  Franklin,
  Rains,
  Wood,
  Camp,
  Upshur,
  Marion,
  Harrison,
  Gregg,
  Van_Zandt,
  Smith,
  Rusk,
  Panola,
  Shelby,
  Henderson,
  Cherokee,
  Anderson,
  Freestone,
  Houston,
  Trinity
}

export default counties
